.formContainer {
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
}

.formGroup {
  margin-bottom: var(--space-4);
  text-align: left;
}

.formGroup label {
  display: block;
  margin-bottom: var(--space-2);
  font-weight: 500;
  color: var(--text-primary);
}

.label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-primary);
}

.input, .textarea {
  width: 100%;
  padding: var(--space-3);
  margin-top: 0.25rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--gray-300);
  background-color: var(--bg-primary);
  color: var(--text-primary);
  font-size: 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.textarea {
  min-height: 100px;
  resize: vertical;
}

.input:focus, .textarea:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
}

.input:hover:not(:focus) {
  border-color: var(--gray-500);
}

.inputError {
  border-color: var(--danger) !important;
}

.errorMessage {
  color: var(--danger);
  margin-top: var(--space-1);
  font-size: 0.875rem;
}

.submitButton {
  width: 100%;
  padding: 0.75rem 1rem;
  background-color: var(--primary);
  color: var(--bg-primary);
  border: none;
  border-radius: 0.375rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.submitButton:hover {
  background-color: var(--primary-dark);
}

.submitButton:disabled {
  background-color: var(--gray-600);
  cursor: not-allowed;
}

.error {
  color: var(--danger);
  background-color: rgba(244, 67, 54, 0.1);
  padding: 0.75rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.checkboxLabel {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.checkboxLabel input[type="checkbox"] {
  height: 18px;
  width: 18px;
  margin-right: var(--space-3);
  accent-color: var(--primary);
}

.select {
  display: block;
  width: 100%;
  padding: var(--space-3);
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-md);
  background-color: var(--bg-primary);
  font-size: 16px;
  color: var(--text-primary);
  appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23A0AEC0'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right var(--space-3) center;
  background-size: 20px;
}

.select:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px var(--primary-light);
  outline: none;
}

.imageUploadContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.fileInput {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.fileInputLabel {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #f5f5f5;
  color: #4A5568;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 14px;
  width: fit-content;
  transition: background-color 0.2s;
}

.fileInputLabel:hover {
  background-color: #e9e9e9;
}

.imagePreviewContainer {
  margin-top: 10px;
}

.logoPreview {
  width: 120px;
  height: 120px;
  object-fit: contain;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;
  padding: 8px;
}